/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CsatByDeviceTagChart_answersReport = {|
  +csatByDeviceTag: ?$ReadOnlyArray<?{|
    +tag: ?string;
    +csat: ?number;
    +count: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CsatByDeviceTagChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "CsatByDeviceTag",
      "name": "csatByDeviceTag",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tag",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "csat",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/CsatByDeviceTagChart/__generated__/CsatByDeviceTagChart_answersReport.graphql.js